<template>
  <div class="here-map">
    <div ref="map" style="height: 260px; width:100%"></div>
  </div>
</template>

<script
  type="text/javascript"
  src="https://js.api.here.com/v3/3.1/mapsjs-core.js"
></script>
<script
  type="text/javascript"
  src="https://js.api.here.com/v3/3.1/mapsjs-service.js"
></script>
<script
  type="text/javascript"
  src="https://js.api.here.com/v3/3.1/mapsjs-ui.js"
></script>
<script
  type="text/javascript"
  src="https://js.api.here.com/v3/3.1/mapsjs-mapevents.js"
></script>

<script>
export default {
  name: "HereMap",
  props: {
    driverPosition: {
      latitude: Number,
      longitude: Number
    },
    deliveryPosition: {
      latitude: Number,
      longitude: Number
    }
  },
  data() {
    return {
      platform: {},
      map: {}
    };
  },
  methods: {
    calculateRouteFromAtoB() {
      var router = this.platform.getRoutingService(),
        routeRequestParams = {
          mode: "fastest;car",
          representation: "display",
          //routeattributes: "waypoints,summary,shape,legs",
          maneuverattributes: "direction,action",
          waypoint0:
            "" +
            this.driverPosition.latitude +
            "," +
            this.driverPosition.longitude +
            "",
          waypoint1:
            "" +
            this.deliveryPosition.latitude +
            "," +
            this.deliveryPosition.longitude +
            ""
        };
      router.calculateRoute(routeRequestParams, this.onSuccess, this.onError);
    },
    onSuccess(result) {
      var route = result.response.route[0];
      this.addRouteShapeToMap(route);
      //this.addManueversToMap(route);
      this.addTwoPointsToMap();
    },
    onError(error) {},
    addRouteShapeToMap(route) {
      var lineString = new H.geo.LineString(),
        routeShape = route.shape,
        polyline;

      routeShape.forEach(function(point) {
        var parts = point.split(",");
        lineString.pushLatLngAlt(parts[0], parts[1]);
      });

      polyline = new H.map.Polyline(lineString, {
        style: {
          lineWidth: 4,
          strokeColor: "rgba(0, 128, 255, 0.7)"
        }
      });

      // Add the polyline to the map
      this.map.addObject(polyline);

      // And zoom to its bounding rectangle
      this.map.getViewModel().setLookAtData({
        bounds: polyline.getBoundingBox()
      });
    },
    addManueversToMap(route) {
      var svgMarkup =
          '<svg width="18" height="18" ' +
          'xmlns="http://www.w3.org/2000/svg">' +
          '<circle cx="8" cy="8" r="8" ' +
          'fill="#1b468d" stroke="white" stroke-width="1"  />' +
          "</svg>",
        dotIcon = new H.map.Icon(svgMarkup, { anchor: { x: 8, y: 8 } }),
        group = new H.map.Group(),
        i,
        j;

      // Add a marker for each maneuver
      for (i = 0; i < route.leg.length; i += 1) {
        for (j = 0; j < route.leg[i].maneuver.length; j += 1) {
          // Get the next maneuver.
          var maneuver = route.leg[i].maneuver[j];
          // Add a marker to the maneuvers group
          var marker = new H.map.Marker(
            {
              lat: maneuver.position.latitude,
              lng: maneuver.position.longitude
            },
            { icon: dotIcon }
          );
          group.addObject(marker);
        }
      }

      // Add the maneuvers group to the map
      this.map.addObject(group);
    },
    addTwoPointsToMap() {
      var svgMarkup1 =
          '<svg xmlns="http://www.w3.org/2000/svg" width="25" height="20" viewBox="0 0 640 512"><path fill="blue" d="M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h16c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm320 0c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z"></path></svg>',
        dotIcon1 = new H.map.Icon(svgMarkup1, { anchor: { x: 8, y: 8 } }),
        svgMarkup2 =
          '<svg width="18" height="18" ' +
          'xmlns="http://www.w3.org/2000/svg">' +
          '<circle cx="8" cy="8" r="8" ' +
          'fill="red" stroke="white" stroke-width="1"  />' +
          "</svg>",
        dotIcon2 = new H.map.Icon(svgMarkup2, { anchor: { x: 8, y: 8 } }),
        group = new H.map.Group();

      var marker1 = new H.map.Marker(
        {
          lat: this.driverPosition.latitude,
          lng: this.driverPosition.longitude
        },
        { icon: dotIcon1 }
      );

      var marker2 = new H.map.Marker(
        {
          lat: this.deliveryPosition.latitude,
          lng: this.deliveryPosition.longitude
        },
        { icon: dotIcon2 }
      );

      group.addObject(marker1);
      group.addObject(marker2);

      // Add the maneuvers group to the map
      this.map.addObject(group);
    }
  },

  mounted() {
    // Initialize communication with the platform
    this.platform = new H.service.Platform({
      apikey: process.env.VUE_APP_HERE_APIKEY
    });

    // Initialize a map
    var defaultLayers = this.platform.createDefaultLayers();
    this.map = new H.Map(this.$refs.map, defaultLayers.vector.normal.map, {
      center: {
        lat: this.deliveryPosition.latitude,
        lng: this.deliveryPosition.longitude
      },
      zoom: 13,
      padding: { top: 10, left: 10, bottom: 10, right: 10 },
      pixelRatio: window.devicePixelRatio || 1
    });

    // add a resize listener to make sure that the map occupies the whole container
    window.addEventListener("resize", () => this.map.getViewPort().resize());

    // Make the map interactive
    // MapEvents enables the event system
    // Behavior implements default interactions for pan/zoom (also on mobile touch environments)
    var behavior = new H.mapevents.Behavior(
      new H.mapevents.MapEvents(this.map)
    );

    // Create the default UI components
    var ui = H.ui.UI.createDefault(this.map, defaultLayers);

    this.calculateRouteFromAtoB();
  }
};
</script>

<style scoped></style>
